// copilot begin — CJS shim：解析 @yeahka/cm-lib 默认导出
/** Host shim: webpack cannot parse default export from @yeahka/cm-lib's prebuilt CJS bundle. */
// eslint-disable-next-line import/no-commonjs, global-require
const lib = require('@yeahka/cm-lib');

export default lib.default;
export const install = lib.install;
export const setCloudManageContext = lib.setCloudManageContext;
export const createCloudManageRoutes = lib.createCloudManageRoutes;
// copilot end
